import i18n from "Localization";
import {withTranslation as withReactTranslation} from "react-i18next";

export function withTranslation(namespace, options) {
    return withReactTranslation.call(this, namespace, {...options, i18n})
}
